import { useEffect } from 'react'
import { APP_BASE_PATH } from '../../_lib/festival'
import { FestivalLoading } from '../FestivalContext/FestivalLoading'
import { useMyself } from '../UserContext'

// Wer eingeloggt ist, gehört ins Portal unter /app
export const EnterApp = () => {
  const { id } = useMyself() || {}

  useEffect(() => {
    // Ein gecachter Benutzer ohne Token darf nicht ins Portal weiterleiten, sonst entsteht eine Schleife
    if (id && localStorage.getItem('token')) {
      window.location.replace(APP_BASE_PATH)
    }
  }, [id])

  return (
    <FestivalLoading />
  )
}
